import { EmployeeDto, getEmptyEmployeeDto } from './user/userTypes';
import { AnswerDto } from './answerTypes';

export interface AnsweredCatalogueDto extends AnsweredCatalogueRequest{
  id: number,
}

export interface AnsweredCatalogueRequest {
  answerer: EmployeeDto,
  answers: AnswerDto[]
}

export function getEmptyAnsweredCatalogue(): AnsweredCatalogueDto {
  return {
    id: -1,
    answerer: getEmptyEmployeeDto(),
    answers: []
  }
}
